import { Component, OnInit } from '@angular/core';
import { NbThemeService } from '@nebular/theme';
import { PeticionesHttpBackEndService } from '../../@core/mock/peticiones-http-backend.service'
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'ngx-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  Actividades: any;
  ActividadImagen: any;
  parametrosUrl:any;

  constructor(private _http: PeticionesHttpBackEndService,private _route: ActivatedRoute) { 
    this.Actividades = {Actividades:[]}
    this._route.queryParams.subscribe(params => {
      this.parametrosUrl = params || null;
    });
  }

  ngOnInit() {
    this._http.getAllPublic("actividades").subscribe(
      result => {
          this.Actividades = result;
      }
    );
  }

}
